import React from 'react';
import styles from './InsightsSkeleton.module.css';

function SkeletonBlock({ h, w = '100%', r = 'var(--radius-clay-sm)' }: { h: string; w?: string; r?: string }) {
  return (
    <div
      className={styles.block}
      style={{ height: h, width: w, borderRadius: r }}
    />
  );
}

function SkeletonCard() {
  return (
    <div className={styles.card}>
      <div className={styles['card-header']}>
        <SkeletonBlock h="2rem" w="2rem" r="var(--radius-clay-sm)" />
        <div className={styles['card-header-text']}>
          <SkeletonBlock h="0.875rem" w="10rem" />
          <SkeletonBlock h="0.6875rem" w="7rem" />
        </div>
      </div>
      <SkeletonBlock h="3rem" />
      <SkeletonBlock h="2rem" />
      <SkeletonBlock h="2rem" w="75%" />
    </div>
  );
}

export function InsightsSkeleton() {
  return (
    <div className={styles.container}>
      {/* Summary row */}
      <div className={styles['summary-row']}>
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={styles['summary-card']}>
            <SkeletonBlock h="2rem" w="2rem" r="var(--radius-clay-sm)" />
            <div className={styles['summary-card-text']}>
              <SkeletonBlock h="0.625rem" w="5rem" />
              <SkeletonBlock h="1.375rem" w="3rem" />
            </div>
          </div>
        ))}
      </div>
      {/* Group cards */}
      <div className={styles.groups}>
        {[0, 1, 2, 3, 4, 5, 6].map((i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </div>
  );
}
